import React, { useState, useEffect, useRef, useCallback } from 'react';
import { galleryImages } from '../mockData';

// Use first 6 best photos for slideshow (faster loading)
const slideshowImages = [...galleryImages].reverse().slice(0, 6);

export const ImageSlideshow = ({ className = "" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState(new Set([0]));
  const [isLoaded, setIsLoaded] = useState(false);
  const intervalRef = useRef(null);

  // Preload next image
  useEffect(() => {
    const nextIndex = (currentIndex + 1) % slideshowImages.length;
    if (!loadedImages.has(nextIndex)) {
      const img = new Image();
      img.src = slideshowImages[nextIndex];
      img.onload = () => {
        setLoadedImages(prev => new Set([...prev, nextIndex]));
      };
    }
  }, [currentIndex, loadedImages]);

  // Auto-advance slideshow
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slideshowImages.length);
    }, 4000); // 4 seconds per image

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleImageLoad = useCallback((index) => {
    if (index === 0) setIsLoaded(true);
  }, []);

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      {/* Only render current and adjacent images */}
      {slideshowImages.map((image, index) => {
        const shouldRender = 
          index === currentIndex || 
          index === (currentIndex + 1) % slideshowImages.length ||
          index === (currentIndex - 1 + slideshowImages.length) % slideshowImages.length;
        
        if (!shouldRender) return null;
        
        return (
          <div
            key={`slide-${index}-${image.slice(-20)}`}
            className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image}
              alt={`Dezire Metal Roofing Project ${index + 1}`}
              className="w-full h-full object-cover"
              loading={index === 0 ? "eager" : "lazy"}
              onLoad={() => handleImageLoad(index)}
              style={{
                willChange: 'opacity',
              }}
            />
          </div>
        );
      })}
      
      {/* Loading placeholder */}
      {!isLoaded && (
        <div className="absolute inset-0 bg-gray-800 animate-pulse" />
      )}
    </div>
  );
};
